import { Button, Form, Input } from "antd";
import React from "react";
import { useFormularioLogin } from "../hooks/examen/useFormularioLogin";
import { Toaster } from 'react-hot-toast';

export const FormularioLogin = () => {


  const { onFinish } = useFormularioLogin()

  return (
    <>
      <Form
        layout="vertical"
        onFinish={ onFinish }
        size="large"
        autoComplete="off"
        // initialValues={{
        //   prematricula: '201600083',
        //   pw: 'saaj98'
        // }}
      >
        <Form.Item
          label="Prematrícula"
          name="prematricula"
          rules={[{ required: false, message: 'Debes agregar una prematrícula' }]}
        >
          <Input/>
        </Form.Item>
        <Form.Item
          label="Contraseña"
          name="pw"
          rules={[{ required: false, message: 'Debes agregar una contraseña' }]}
        >
          <Input.Password/>
        </Form.Item>
        <Form.Item>
          <Button type="primary" htmlType="submit" block id="btn_submit">
            Acceder
          </Button>
        </Form.Item>
      </Form>
      <Toaster position="bottom-center"/>
    </>
  );
};
